import { JsonFormsRendererRegistryEntry } from "@jsonforms/core";

/**
 * Nucleus-specific custom renderers for the Form Studio preview.
 * These renderers handle domain-specific field types like AssociateLookupControl.
 */
export const CUSTOM_RENDERERS: JsonFormsRendererRegistryEntry[] = [
  // Add Nucleus-specific renderers here as they are implemented
  // Example: { tester: associateLookupTester, renderer: AssociateLookupControl }
];

/**
 * Custom field type definitions for the Form Studio editor dropdown.
 * These appear in the "Field Type" selector when adding new fields.
 */
export const CUSTOM_FIELD_TYPES: { value: string; label: string; schema: { type: string; format: string } }[] = [
  // Add custom field types here once their corresponding renderers are implemented
  // Example: { value: "associateLookup", label: "Associate Lookup", schema: { type: "string", format: "associate-lookup" } }
];
